// extracted by mini-css-extract-plugin
module.exports = {"productDiscountName":"p+iyY"};